import styled from "@emotion/styled";
import { size } from "polished";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { getModuleThemeColors } from "@brexhq/next/src/components/pageBuilder/ModuleLayout";
import { type ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";

export const TEST_ID_RIGHT_SCROLL_BUTTON = "RIGHT_SCROLL_BUTTON";
export const TEST_ID_LEFT_SCROLL_BUTTON = "LEFT_SCROLL_BUTTON";

const ScrollButtonWrapper = styled.button<{
  moduleTheme: ModuleThemeType;
}>(({ theme, moduleTheme }) => {
  const { standard } = getModuleThemeColors(moduleTheme);

  const hoverBGColor = standard.textPrimary;
  const hoverColor = standard.background;
  return {
    ...size(50),
    cursor: "pointer",
    backgroundColor:
      moduleTheme === "PrimaryPaper"
        ? theme.colors.background.primary
        : theme.colors.background.tertiary,
    color: theme.colors.content.primary,
    borderRadius: theme.radius.half,
    border: "none",
    "&:hover": {
      backgroundColor: hoverBGColor,
    },

    "&:hover div": {
      color: hoverColor,
    },

    [theme.breakpoints.SML]: {
      marginTop: 0,
    },
    "&:disabled": {
      backgroundColor:
        moduleTheme === "PrimaryGray"
          ? theme.colors.background.primary
          : theme.colors.background.secondary,
    },
    "&:disabled div": {
      color: theme.colors.content.disabled,
    },
  };
});

export const ScrollButton = ({
  onClick,
  orientation,
  canScroll,
  moduleTheme,
}: {
  onClick: () => void;
  orientation: "left" | "right";
  canScroll: boolean;
  moduleTheme: ModuleThemeType;
}) => {
  return (
    <ScrollButtonWrapper
      disabled={!canScroll}
      onClick={onClick}
      data-testid={
        orientation === "left"
          ? TEST_ID_LEFT_SCROLL_BUTTON
          : TEST_ID_RIGHT_SCROLL_BUTTON
      }
      moduleTheme={moduleTheme}
    >
      <Container direction="column" alignItems="center" justifyContent="center">
        {orientation === "left" ? "<-" : "->"}
      </Container>
    </ScrollButtonWrapper>
  );
};
